import { useEffect } from 'react';
import { useNavigate } from 'react-router';

const isTypingTarget = (el: EventTarget | null) =>
  el instanceof HTMLElement &&
  (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT' || el.isContentEditable);

/** `/` zet de cursor in het zoekveld, waar je ook bent op de publieke site.
 *  Staat er geen zoekveld op de pagina (artikel, leerpad), dan ga je naar de
 *  zoekpagina met het veld al gefocust. Dezelfde toets als op GitHub en in
 *  de meeste documentatiesites, dus wie hem kent, probeert hem. Rendert niets. */
export function SearchHotkey() {
  const navigate = useNavigate();
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
      if (isTypingTarget(e.target)) return;
      if (document.querySelector('[role="dialog"]')) return;
      e.preventDefault();
      const veld = document.querySelector<HTMLInputElement>('input[data-kb-search]');
      if (veld) { veld.focus(); veld.select(); return; }
      navigate('/search?focus=1', { viewTransition: true });
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [navigate]);
  return null;
}
